module.exports = __webpack_public_path__ + "img/配套升学规划@2x.b12d345c.png";